import { GridColDef } from "@mui/x-data-grid-pro";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AddressCell } from "@/components/grid/cells/AddressCell";
import { DeviceActivityCell } from "@/components/grid/cells/DeviceActivityCell";
import { RenderHeader } from "@/components/grid/cells/RenderHeader";
import { getFirmwareValue } from "@/utilities/getFirmwareValue";

export default function useFirmwareColumns() {
  const { t } = useTranslation();
  const initialColumns: GridColDef[] = useMemo(
    () => [
      {
        field: "device.name",
        headerName: t("deviceFirmware.name", "Name"),
        renderHeader: RenderHeader,
        renderCell: DeviceActivityCell,
        width: 400,
        valueGetter: (_, row) => row.device.name,
      },

      {
        field: "device.serialNumber",
        headerName: t("deviceFirmware.deviceSerial", "Fahrzeug Seriennummer"),
        renderHeader: RenderHeader,
        width: 200,
        valueGetter: (_, row) => row.device.serialNumber,
      },
      {
        field: "device.deviceType",
        headerName: t("deviceFirmware.deviceType", "Device Typ"),
        renderHeader: RenderHeader,
        valueGetter: (_, row) => row.device.deviceType,
      },
      {
        minWidth: 100,
        width: 250,
        field: "zones",
        headerName: t("faultOverview.address", "address"),
        renderHeader: RenderHeader,
        renderCell: AddressCell,
        valueGetter: (_, row) => (row.address || row.zones ? row.zones + " " + row.address : null),
      },
      {
        field: "uiid",
        headerName: t("deviceFirmware.uiid"),
        renderHeader: RenderHeader,
        width: 400,
      },
      {
        field: "firmware",
        headerName: t("deviceFirmware.firmware", "Firmware"),
        renderHeader: RenderHeader,
        width: 300,
        valueGetter: (_, row) => getFirmwareValue(row.device) || "---",
      },
      {
        field: "uReaderFirmware",
        headerName: t("deviceFirmware.ufirmware", "uReaderFirmware"),
        renderHeader: RenderHeader,
      },
      {
        field: "uReaderSerialNumber",
        headerName: t("deviceFirmware.serialNumber", "SerialNumber"),
        renderHeader: RenderHeader,
        width: 200,
      },
    ],
    [t],
  );
  return { initialColumns };
}
